/**
 * yd-connect-orbit: Connect 段进场——8 设备逐个刷绿 + 中心数字 0→8。无外部库。
 * 源自 web-hand-off connect-orbit.js：删 partials:loaded，补 shopify:section:load。
 * 监听 [data-orbit]；[data-orbit-device] 逐个 .is-on；[data-orbit-count] 计数。
 * 尊重 reduced-motion（直接终值）。幂等。
 */
(function () {
  function setup(sec) {
    if (sec.dataset.orbitReady) return;
    sec.dataset.orbitReady = '1';
    var devices = [].slice.call(sec.querySelectorAll('[data-orbit-device]'));
    var countEl = sec.querySelector('[data-orbit-count]');
    if (!devices.length) return;
    function finish() {
      devices.forEach(function (d) { d.classList.add('is-on'); });
      if (countEl) countEl.textContent = String(devices.length);
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { finish(); return; }
    function play() {
      devices.forEach(function (d, i) {
        setTimeout(function () {
          d.classList.add('is-on');
          if (countEl) countEl.textContent = String(i + 1);
        }, 140 + i * 150);
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        play();
      });
    }, { threshold: 0.4 });
    io.observe(sec);
  }
  function init() { document.querySelectorAll('[data-orbit]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
